import React from 'react'
import styled from 'styled-components'
import FormGroup, {FormGroupProps} from '@mui/material/FormGroup'
import formGroupStyles from './form_group.styles'

type ApFormGroupProps = FormGroupProps
const apAtomName = {ap_atom_name: 'formgroupAtom'}
const FormGroupAtom = styled((props: ApFormGroupProps) => (
  <FormGroup {...apAtomName} {...props}>
    {props.children}
  </FormGroup>
))`
  ${formGroupStyles}
`

export default FormGroupAtom
